import { apiSlice } from "../apiSlice";

export const teamMembersApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getTeamMembers: builder.query({
      query: () => "/team",
    }),
  }),
});

export const { useGetTeamMembersQuery } = teamMembersApi;
